import { GoogleMap, Marker, Circle, Polyline, InfoWindow } from 'vue3-google-map';
import Autocomplete from '~/components/google_maps/GmapAutocomplete.vue';

// `vue3-google-map` (Vue 3) ships without an `Autocomplete` component
// (vue2-google-maps had one). Local Vue 3 wrapper around
// `google.maps.places.Autocomplete` keeps the existing GmapAutocomplete API
// (`:value`, `@input`, `@place_changed`, `select-first-on-enter`).

const GoogleMaps = {
  install(app, googleMapsKey) {
    if (!googleMapsKey) {
      throw new Error('Google Maps key is required');
    }

    app.provide('googleMapsKey', googleMapsKey);

    app.component('GmapMap', GoogleMap);
    app.component('GmapMarker', Marker);
    app.component('GmapCircle', Circle);
    app.component('GmapPolyline', Polyline);
    app.component('GmapInfoWindow', InfoWindow);
    app.component('GmapAutocomplete', Autocomplete);
  },
};

GoogleMaps.Autocomplete = Autocomplete;

export default GoogleMaps;
